import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actionCreators from '../actions'

import Header from 'components/Header'
import Logo from './Logo'
import IndieButton from './IndieButton'
import CesiumWidget from 'components/CesiumWidget'
import InfoBox from 'components/InfoBox'
import GeoMarker from 'components/GeoMarker'
import MasterForm from 'components/MasterForm'
import Intro from 'components/Intro'
import Zoom from 'components/Zoom'
import Ambilight from 'components/Ambilight'
import Localizer from 'components/Localizer'
import Footer from 'components/Footer'

class CoreLayout extends React.Component {

  constructor(props) {
    super(props)
  }
  
  render () {
    return (
      <div>

        <Header
          style={{position:'absolute',top: 0,left: 0, right: 0}}
          mode={this.props.map.mode}
          setMode={this.props.setMode}
          setBounds={this.props.setBounds}
          unsetSelectedEntity={this.props.unsetSelectedEntity}
        />
        
        <Logo />

        <IndieButton 
          showForm={this.props.map.showForm}
          setShowForm={this.props.setShowForm}
        />

        <CesiumWidget 
          mode={this.props.map.mode}
          zoom={this.props.map.zoom} 
          setCameraIsFlying={this.props.setCameraIsFlying}
          entityIsLoading={this.props.entityIsLoading}

          targetBounds={this.props.map.targetBounds}
          targetCenter={this.props.map.targetCenter} 
          targetHeight={this.props.map.targetHeight} 
          targetDuration={this.props.map.targetDuration} 

          setBounds={this.props.setBounds}
          setCenterHeight={this.props.setCenterHeight}
          setViewport={this.props.setViewport}

          currentBounds={this.props.map.currentBounds}
          currentCenter={this.props.map.currentCenter} 
          currentHeight={this.props.map.currentHeight} 
          currentMagnitude={this.props.map.currentMagnitude} 

          entityIsLoading={this.props.entityIsLoading}
          setEntityIsLoading={this.props.setEntityIsLoading}
          unsetEntityIsLoading={this.props.unsetEntityIsLoading}

          selectedEntity={this.props.selectedEntity}
          unsetSelectedEntity={this.props.unsetSelectedEntity}
          
          loadBatteriesByBounds={this.props.loadBatteriesByBounds}
          loadBattery={this.props.loadBattery}
          
          loadVideosByBounds={this.props.loadVideosByBounds}
          loadVideo={this.props.loadVideo}

          loadAmbassadorsByBounds={this.props.loadAmbassadorsByBounds}
          loadAmbassador={this.props.loadAmbassador}

          loadAwardsByBounds={this.props.loadAwardsByBounds}
          loadAward={this.props.loadAward}
        />
        
        <InfoBox 
          entityIsLoading={this.props.entityIsLoading}
          entityType={this.props.entityType}
          selectedEntity={this.props.selectedEntity}
          showForm={this.props.map.showForm}
          setShowForm={this.props.setShowForm}
          cameraIsFlying={this.props.map.cameraIsFlying}
        />

        <GeoMarker 
          entityIsLoading={this.props.entityIsLoading}
          selectedEntity={this.props.selectedEntity}
          cameraIsFlying={this.props.map.cameraIsFlying}
        />
      
        <MasterForm 
          mode={this.props.map.mode}
          showForm={this.props.map.showForm}
          setShowForm={this.props.setShowForm}
          selectedEntity={this.props.selectedEntity}
        />

        <Intro />

        <Zoom 
          zoomIncrement={this.props.zoomIncrement}
          zoomDecrement={this.props.zoomDecrement}
          unsetSelectedEntity={this.props.unsetSelectedEntity}
        />
        
        <Ambilight />
        
        <Localizer
          unsetSelectedEntity={this.props.unsetSelectedEntity}
          setCenterHeight={this.props.setCenterHeight}
        />
        
        <Footer />
        
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    map: state.map,
    selectedEntity: state.entities.selected,
    entityIsLoading: state.entities.entity_is_loading,
    entityType: state.entities.entity_type,
  }
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch)
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoreLayout)


// WEBPACK FOOTER //
// ./src/components/CoreLayout.js